module.exports = __webpack_public_path__ + "static/spaceKitchenDesktop_x2-713c603d6e203dd91685ec84224c72c0.jpg";